/**
 * /app/trust — tenant-wide entry into the trust detail page.
 *
 * Replaced the legacy fixture redirect (hardcoded 'vandermerwe-family-trust').
 * Routes the single-trust case to /app/trusts/$id directly, otherwise
 * surfaces the picker so the user explicitly chooses which trust to open.
 */

import { createFileRoute } from '@tanstack/react-router';
import { TrustScopedLanding } from '../../components/screens/trust-scoped-landing';

export const Route = createFileRoute('/app/trust')({
  component: () => (
    <TrustScopedLanding
      suffix=""
      eyebrow="Trust"
      title="Your trust"
      emptyHelp="You don't have any trusts under your administration yet. Onboarding routes here once your trust deed and identity verification are accepted."
    />
  ),
});
